module.exports = __webpack_public_path__ + "img/first.96dcb9f5.png";